import { memo } from 'react';
import { CustomTheme } from '../../theme/customTheme';

type Props = {
  size?: number;
  color?: string;
};

function BusIcon({ size = 50, color = CustomTheme.colors.contentPrimary }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size}
      zoomAndPan="magnify"
      viewBox="0 0 810 809.999993"
      height={size}
      preserveAspectRatio="xMidYMid meet"
      version="1.0"
    >
      <defs>
        <clipPath id="442b426601">
          <path
            d="M 353 100.804688 L 450 100.804688 L 450 111 L 353 111 Z M 353 100.804688 "
            clipRule="nonzero"
          />
        </clipPath>
      </defs>
      <path
        fill={color}
        d="M 492.546875 708.386719 C 510.570312 709 529.183594 684.578125 530.003906 670.617188 C 530.21875 666.945312 530.148438 325.996094 530.273438 316.347656 C 530.585938 289.332031 530.308594 240.671875 528.335938 180.339844 C 525.960938 167.636719 520.03125 149.960938 514.648438 132.867188 C 507.769531 111.011719 481.957031 107.933594 462.933594 106.113281 C 449.578125 104.828125 355.066406 105.546875 342.339844 106.113281 C 328.777344 106.71875 292.875 111.824219 285.996094 134.882812 C 281.890625 149.855469 281.730469 170.425781 280.265625 181.816406 C 280.445312 251.796875 280.1875 294.546875 280.144531 318.757812 C 280.117188 329.488281 280.390625 670.640625 280.519531 674.847656 C 280.929688 689.480469 298.238281 708.929688 310.914062 708.929688 C 358.75 708.929688 477.613281 707.886719 492.546875 708.386719 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#ffffff"
        d="M 506.476562 175.40625 C 509.714844 169.808594 504.859375 165.21875 495.6875 163.664062 C 479.078125 160.851562 446.402344 157.308594 400.050781 157.308594 C 355.257812 157.308594 324.28125 161.191406 308.480469 163.425781 C 299.878906 164.65625 295.640625 167.511719 298.871094 173.378906 C 300.558594 176.414062 314.421875 198.644531 320.792969 208.835938 C 322.71875 211.925781 325.585938 213.910156 330.847656 212.898438 C 336.105469 211.871094 345.140625 207.855469 401.523438 207.855469 C 457.914062 207.855469 472.890625 211.871094 476.535156 212.898438 C 480.179688 213.910156 484.160156 212.03125 485.957031 209.097656 C 491.824219 199.550781 504.503906 178.824219 506.476562 175.40625 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#ffffff"
        d="M 512.230469 676.621094 C 515.664062 680.042969 510.511719 682.851562 500.773438 683.792969 C 483.144531 685.515625 448.464844 687.675781 399.265625 687.675781 C 351.726562 687.675781 318.855469 685.300781 302.089844 683.933594 C 292.953125 683.191406 288.449219 681.445312 291.882812 677.871094 C 293.667969 676.007812 308.382812 662.429688 315.144531 656.207031 C 317.195312 654.320312 320.238281 653.101562 325.816406 653.734375 C 331.394531 654.351562 340.992188 656.804688 400.835938 656.804688 C 460.679688 656.804688 476.578125 654.351562 480.449219 653.734375 C 484.3125 653.101562 488.542969 654.257812 490.453125 656.046875 C 496.671875 661.890625 510.132812 674.527344 512.230469 676.621094 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#ffffff"
        d="M 519.171875 652.660156 L 519.171875 621.675781 L 491.871094 621.675781 C 492.394531 631.191406 493.28125 641.128906 496.921875 647.199219 C 500.5625 653.261719 519.171875 652.660156 519.171875 652.660156 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#ffffff"
        d="M 490.851562 235.636719 C 490.851562 210.15625 519.589844 181.816406 519.589844 181.816406 L 519.589844 306.804688 L 490.851562 306.804688 C 490.851562 306.804688 490.851562 261.117188 490.851562 235.636719 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#ffffff"
        d="M 291.347656 656.074219 L 291.347656 625.09375 L 318.644531 625.09375 C 318.132812 634.613281 317.234375 644.554688 313.59375 650.625 C 309.945312 656.695312 291.347656 656.074219 291.347656 656.074219 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#ffffff"
        d="M 319.0625 237.589844 C 319.0625 212.800781 290.316406 185.242188 290.316406 185.242188 L 290.316406 306.804688 L 319.0625 306.804688 C 319.0625 306.804688 319.0625 262.367188 319.0625 237.589844 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#ffffff"
        d="M 519.894531 408.582031 L 519.894531 318.5 L 491.15625 318.5 C 491.15625 318.5 491.15625 374.507812 491.15625 408.582031 L 519.894531 408.582031 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#ffffff"
        d="M 319.332031 410.777344 C 319.332031 410.484375 319.363281 410.183594 319.363281 409.894531 C 319.363281 377.160156 319.363281 318.5 319.363281 318.5 L 290.625 318.5 L 290.625 410.777344 L 319.332031 410.777344 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#ffffff"
        d="M 519.894531 510.507812 L 519.894531 420.445312 L 491.15625 420.445312 C 491.15625 420.445312 491.15625 476.441406 491.15625 510.507812 L 519.894531 510.507812 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#ffffff"
        d="M 319.332031 512.710938 C 319.332031 512.417969 319.363281 512.121094 319.363281 511.828125 C 319.363281 479.101562 319.363281 420.445312 319.363281 420.445312 L 290.625 420.445312 L 290.625 512.710938 L 319.332031 512.710938 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#ffffff"
        d="M 519.894531 612.453125 L 519.894531 522.371094 L 491.15625 522.371094 C 491.15625 522.371094 491.15625 578.378906 491.15625 612.453125 L 519.894531 612.453125 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#ffffff"
        d="M 319.332031 614.648438 C 319.332031 614.355469 319.363281 614.058594 319.363281 613.773438 C 319.363281 581.046875 319.363281 522.371094 319.363281 522.371094 L 290.625 522.371094 L 290.625 614.648438 L 319.332031 614.648438 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill={color}
        d="M 244.132812 204.097656 C 244.132812 204.097656 277.332031 196.070312 282.925781 194.667969 C 288.523438 193.265625 278.125 182.671875 289.761719 182.003906 C 301.40625 181.332031 299.128906 171.773438 290.886719 171.511719 C 282.648438 171.246094 251.785156 189.964844 247.960938 194.667969 C 244.132812 199.390625 244.132812 204.097656 244.132812 204.097656 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill={color}
        d="M 565.648438 204.097656 C 565.648438 204.097656 532.449219 196.070312 526.863281 194.667969 C 521.261719 193.265625 531.664062 182.671875 520.027344 182.003906 C 508.378906 181.332031 510.660156 171.773438 518.894531 171.511719 C 527.132812 171.246094 558.003906 189.964844 561.824219 194.667969 C 565.648438 199.390625 565.648438 204.097656 565.648438 204.097656 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill={color}
        d="M 432.714844 210.09375 C 432.832031 208.273438 432.320312 206.382812 430.394531 204.988281 C 425.132812 201.167969 384.257812 200.652344 376.171875 204.988281 C 373.328125 206.507812 372.5 208.347656 372.597656 210.09375 L 432.714844 210.09375 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#ffffff"
        d="M 331.410156 113.796875 C 332.589844 118.84375 323.203125 129.695312 314.601562 135.589844 C 304.820312 142.3125 292.324219 150.085938 290.851562 147.703125 C 288.121094 143.265625 296.507812 127.039062 300.511719 123.652344 C 305.894531 119.089844 330.214844 108.746094 331.410156 113.796875 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#ffffff"
        d="M 470.910156 113.796875 C 469.726562 118.84375 479.109375 129.695312 487.714844 135.589844 C 497.5 142.3125 509.992188 150.085938 511.457031 147.703125 C 514.195312 143.265625 505.808594 127.039062 501.800781 123.652344 C 496.414062 119.089844 472.105469 108.746094 470.910156 113.796875 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <g clipPath="url(#442b426601)">
        <path
          fill={color}
          d="M 449.023438 110.050781 L 353.109375 110.050781 L 353.109375 100.746094 L 449.023438 100.746094 L 449.023438 110.050781 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <path
        fill="#ffffff"
        d="M 309.097656 704.65625 L 345.390625 706.152344 L 345.8125 695.816406 C 345.8125 695.816406 317.097656 695.539062 314.851562 697.332031 C 312.609375 699.121094 309.097656 704.65625 309.097656 704.65625 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#ffffff"
        d="M 494.941406 704.65625 L 458.660156 706.152344 L 458.226562 695.816406 C 458.226562 695.816406 486.945312 695.539062 489.183594 697.332031 C 491.425781 699.121094 494.941406 704.65625 494.941406 704.65625 "
        fillOpacity="1"
        fillRule="nonzero"
      />
    </svg>
  );
}

export default memo(BusIcon);
